import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { DisplayReport } from "./types/type";
import { Button } from "./components/Button";
import usePartnerAwareNavigate from "src/hooks/usePartnerAwareNavigate";

export const LatestReport: React.FC<{ report?: DisplayReport }> = ({
  report,
}) => {
  const navigate = usePartnerAwareNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleViewReport = (sessionId: string) => {
    navigate(`report?interviewSessionId=${sessionId}`);
  };

  return (
    <div
      className="relative bg-white rounded p-8 transition-transform duration-500 overflow-hidden flex flex-col h-full"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        boxShadow: isHovered
          ? "0 8px 32px rgba(255, 209, 45, 0.15)"
          : "0 4px 16px rgba(0, 0, 0, 0.05)",
      }}
    >
      {/* Background with gradient */}
      {report ? (
        <div
          className="absolute transition-transform duration-500"
          style={{
            background: "linear-gradient(145deg, #FFF 10.21%, #FFD12D 85.25%)",
            borderRadius: "50%",
            opacity: 0.95,
            right: "-15%",
            bottom: "-34%",
            width: "70%",
            height: "70%",
            transform: `scale(${isHovered ? 1.02 : 1})`,
            transformOrigin: "bottom right",
          }}
        />
      ) : (
        <div
          className="absolute transition-transform duration-500"
          style={{
            background: "linear-gradient(145deg, #FFF 10.21%, #81848F 85.25%)",
            borderRadius: "50%",
            opacity: 0.15,
            right: "-15%",
            bottom: "-15%",
            width: "70%",
            height: "70%",
            transform: `scale(${isHovered ? 1.02 : 1})`,
            transformOrigin: "bottom right",
          }}
        />
      )}

      {/* Subtle glow overlay */}
      <div
        className="absolute inset-0 rounded transition-opacity duration-500"
        style={{
          //   background: report
          //     ? "radial-gradient(circle at center, rgba(240, 189, 7, 0.92) 0%, transparent 80%)"
          //     : "radial-gradient(circle at center, rgba(235, 235, 26, 0.05) 0%, transparent 80%)",
          opacity: isHovered ? 1 : 0,
        }}
      />

      <div className="relative flex flex-col flex-grow">
        {/* Title with animation */}
        <h2 className="text-2xl font-bold mb-8 text-black">Latest Report</h2>

        {report ? (
          <>
            {/* Info Grid with staggered animations */}
            <div className="grid grid-cols-3 gap-8 mb-14">
              {[
                { label: "Case Name", value: report.caseName },
                {
                  label: "Overall Score",
                  value: report.overallScore,
                },
                { label: "Time Used", value: report.timeUsed },
              ].map((item) => (
                <div key={item.label}>
                  <h3 className="text-slate-600 mb-2 font-medium">
                    {item.label}
                  </h3>
                  <p className="font-semibold text-black">{item.value}</p>
                </div>
              ))}
            </div>

            {/* Updated View Button */}
            <div className="mt-auto">
              <Button
                onClick={() => handleViewReport(report.sessionId)}
                className="
          group
          relative
          inline-flex
          items-center
          justify-center
          border
          border-gray-300
          px-8
          py-2
          bg-white
          text-black
          rounded
          transition-colors
          duration-100
          hover:bg-[#FFD12D]
          hover:text-white
    "
              >
                <span className="transition-all bottom-2">View</span>
                <ArrowRight
                  size={18}
                  className="
        absolute
        right-4
        opacity-0
        -translate-x-2
        transition-all
        duration-300
        
        group-hover:opacity-100
        group-hover:translate-x-2
      "
                />
              </Button>
            </div>
          </>
        ) : (
          <div className="flex flex-col flex-grow">
            <div className="flex flex-col items-center justify-center flex-grow">
              <p className="text-slate-600 text-lg mb-4">
                No Reports Available
              </p>
              <p className="text-slate-500 text-sm text-center max-w-md">
                Complete a mock interview to generate your first report and
                track your progress.
              </p>
            </div>
            <div className="mt-auto flex justify-center">
              <Button
                onClick={() => navigate("case-selection")}
                className="
                  group
                  relative
                  inline-flex
                  items-center
                  justify-center
                  border
                  border-gray-300
                  px-8
                  py-2
                  bg-white
                  text-black
                  rounded
                  transition-colors
                  duration-100
                  hover:bg-[#FFD12D]
                  hover:text-white
                "
              >
                <span className="transition-all">Start</span>
                <ArrowRight
                  size={18}
                  className="
                    absolute
                    right-4
                    opacity-0
                    -translate-x-2
                    transition-all
                    duration-300
                    group-hover:opacity-100
                    group-hover:translate-x-2
                  "
                />
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LatestReport;
